import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';
import { getProjectNameHeader } from '@/utils/imUtils';

const baseUrl = envConfig.formalServer + '/plat/admin/im/channel/member/';

function baseApi() {

    function insert(data, projectName) {
        return Post(baseUrl + 'insertImChannelMember', data, getProjectNameHeader(projectName));
    }

    function deleteData(data, projectName) {
        return Post(baseUrl + 'deleteImChannelMember', data, getProjectNameHeader(projectName));
    }

    function update(data, projectName) {
        return Post(baseUrl + 'updateImChannelMember', data, getProjectNameHeader(projectName));
    }

    function memberExit(data, projectName) {
        return Post(baseUrl + 'memberExit', data, getProjectNameHeader(projectName));
    }

    function muteMember(data, projectName) {
        return Post(baseUrl + 'muteMember', data, getProjectNameHeader(projectName));
    }

    function query(data, projectName) {
        return Post(baseUrl + 'queryImChannelMember', data, getProjectNameHeader(projectName));
    }

    return {
        insert, deleteData, update, query, memberExit, muteMember
    };
}

export const imChannelMemberApi = baseApi();
